import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withKeys as _withKeys, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, unref as _unref, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "common-forms" }
const _hoisted_2 = {
  key: 5,
  style: {"display":"flex","align-items":"center"}
}
const _hoisted_3 = { style: {"text-align":"right"} }

import request from '@/utils/request'
import { DoubleRightOutlined } from '@ant-design/icons-vue';
import { h, ref, computed, onMounted, watch, toRaw, watchEffect, nextTick } from 'vue';

import CpeH5BloggerSearch from '@/components/searchComps/CpeH5BloggerSearch.vue';
import CpeBloggerSearch from '@/components/searchComps/CpeBloggerSearch.vue';
import CpeDirectorSearch from '@/components/searchComps/CpeDirectorSearch.vue';
import CpePlatformSearch from '@/components/searchComps/CpePlatformSearch.vue';
import CpeProjectSearch from '@/components/searchComps/CpeProjectSearch.vue';


import DirectorSearchCpa from '@/components/searchComps/DirectorSearchCpa.vue'
import DirectorManagerSearchCpa from '@/components/searchComps/DirectorManagerSearchCpa.vue'
import BloggerInviteSearchCpa from '@/components/searchComps/BloggerInviteSearchCpa.vue'
import BloggerSearchCpa from '@/components/searchComps/BloggerSearchCpa.vue'
import PlatformSearchCpa from '@/components/searchComps/PlatformSearchCpa.vue'
import KeywordSearchCpa from '@/components/searchComps/KeywordSearchCpa.vue'

import AllProjectsSearch from '@/components/searchComps/AllProjectsSearch.vue'
import AllUsersSearch from '@/components/searchComps/AllUsersSearch.vue'

import _ from 'lodash'
/**
 * formList 的类型
 * input--输入框
 * select--下拉框（multiple为true时，value是数组，list是下拉数据，默认label，value）
 * date -- 时间 已经格式化 YYYY-MM-DD
 * daterange -- 时间区间 value是数组，两个值 已经格式化 YYYY-MM-DD
 * inputRange 两个区间值，字段为fields，里面是两个对应的字段，value也是数组，index对应
 * selectDatas -- 点击会出现弹窗，选择后将数据填充到输入框里。
 */

import { useRoute } from 'vue-router';
import { useStore } from 'vuex'

import dayjs from 'dayjs';


export default /*@__PURE__*/_defineComponent({
  __name: 'SearchForms',
  props: {
  formDatas: {
    type: Object,
  }
},
  emits: ['searchDatas','searchDatasByBtn'],
  setup(__props, { expose: __expose, emit: __emit }) {

const store = useStore()

const emits = __emit
const props = __props
const route = useRoute()
const isShowFold = ref(true)
const formList = ref([])

const isFold = ref(true)
const isInit = ref(true)

const user_role = computed(() => store.state.user.role)

const buttonSpan = computed(()=> {
  let total = formList.value.filter(v=>v.show).length
  let span = (3-(total % 3)) * 8 || 24
  return span
})

const changeValues = ($event = null, item = null, isSearchBtn = false) => {
  let params = {}
  let list = toRaw(formList.value)
  list.forEach(v=>{
    if (v.type=='inputRange' || v.type=='daterange' || v.type=='monthrange') {
      let result1 = ''
      let result2 = ''
      console.log(123, v.value)
      // 有时间的，需要判断是否有length值
      if (v.value && v.value.length) {
        // 兼容原来cpa项目的时间
        if (v.type=='daterange' && v.timeStr) {
          params[v.field] = [dayjs(v.value[0]).unix(), dayjs(v.value[1]).unix()].join(',')
        } else if (v.type=='daterange' && v.needString) {
          params[v.field] = [v.value[0], v.value[1]].filter(Boolean).join(',')
        } else if (v.type=='inputRange' && v.needString) {
          params[v.field] = [v.value[0], v.value[1]].filter(Boolean).join(',')
        } else {
          // 数字类型的会转换为数字类型
          result1 = v.isNumber && v.value[0] ? parseFloat(v.value[0]) : v.value[0]
          result2 = v.isNumber && v.value[1] ? parseFloat(v.value[1]) : v.value[1]
          params[v.fields[0]] = result1
          params[v.fields[1]] = result2
        }
      }
    } else if (v.type=='date') {
      if (v.value) {
        params[v.field] = v.timeStr ? dayjs(v.value).unix() : dayjs(v.value).format('YYYY-MM-DD')
      } else {
        params[v.field] = ''
      }
    } else if (v.mode=='multiple'&&v.needString) {
      params[v.field] = v.value && v.value.length ? v.value.join(',') : ''
    } else if (v.type=='input'&&v.needMore) {
      let result =  v.value?.split(',').map(v=>v.trim())
      params[v.field] = v.needArray ? result : result.join(',')
    }else {
      params[v.field] = v.value
    }
  })
  console.log('params', params)
  emits('searchDatas', params)
}
const onSearch = () => {
  changeValues(null,null,true)
}
function onReset() {
  formList.value = _.cloneDeep(props.formDatas?.data)
  setHeight()
  onSearch()
}
const initSelects = () => {
  if (!formList.value.length) return false
  formList.value.forEach((v, i) => {
    if (v.type=='select' && v.requestUrl) {
      getSelectDatas(v, i)
    }
    if (route.query && Object.keys(route.query).includes(v.field) && isInit.value) {
      v['value'] = route.query[v.field]
    }
  })
  setHeight()
  if (isInit.value) {
    isInit.value = false
    onSearch()
  }
}

const setHeight = () => {
  if (formList.value.length > 5) {
    isShowFold.value = true
    isFold.value = true
    formList.value = formList.value.map((v,i)=>{
      return {
        ...v,
        show: i<5
      }
    })
  } else {
    isShowFold.value = false
    isFold.value = false
    formList.value = formList.value.map((v,i)=>{
      return {
        ...v,
        show: true
      }
    })
  }

}

function getSelectDatas(item, index) {
  request.get(item.requestUrl).then(({data})=> {
    console.log(12345,data)
    if (item.props) {
      if (data.list && data.list.length) {
        data.list = data.list.map(v=>{
          v['label'] = v[item.props.label]
          v['value'] = v[item.props.value]
          return v
        })
        formList.value[index].list = data.list
      } else if (data && data.length) {
        data = data.map(v=>{
          if (typeof v == 'string') {
            return {label:v,value:v}
          }
          v['label'] = v[item.props.label]
          v['value'] = v[item.props.value] || v['value']
          return v
        })
        formList.value[index].list = data
      }
      if (item.distinct) {
        formList.value[index].list = Array.from(new Set(formList.value[index].list.map(item => item.value))).map(value => {
          return formList.value[index].list.find(item => item.value === value);
        })
      }
      
    } else if (item.isArrayData && data.length) {
      let res = data.map(v=>({value:v,label:v}))
      console.log(123, res)
      formList.value[index].list = [...res]
    }
    
  })
}


onMounted(async () => {
  await getForms()
  if (formList.value.length) {
    initSelects()
  }
  
})

async function getForms() {

  // item.role ? item.role?.includes(user_role)
  let list = _.cloneDeep(props.formDatas?.data)
  list = list.filter(item=> {
    return item.role ? item.role?.includes(user_role.value) : true
  })

  formList.value = _.cloneDeep(list)
}

function changeFoldStatus() {
  isFold.value = !isFold.value
  formList.value = formList.value.map((v,i)=>{
    return {
      ...v,
      show: isFold.value ? i<5 : true
    }
  })
}

__expose({
  changeValues,
  onReset
})


return (_ctx: any,_cache: any) => {
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_radio_group = _resolveComponent("a-radio-group")!
  const _component_a_range_picker = _resolveComponent("a-range-picker")!
  const _component_a_date_picker = _resolveComponent("a-date-picker")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_form = _resolveComponent("a-form")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_a_form, {
        labelAlign: __props.formDatas.labelAlign,
        colon: false,
        "label-col": { style: { width: __props.formDatas.labelWidth+'px' } }
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_row, { gutter: 24 }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(formList.value, (item, index) => {
                return _withDirectives((_openBlock(), _createBlock(_component_a_col, {
                  span: 8,
                  key: index
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_form_item, {
                      label: item.label
                    }, {
                      default: _withCtx(() => [
                        (item.type=='input')
                          ? (_openBlock(), _createBlock(_component_a_input, {
                              key: 0,
                              value: item.value,
                              "onUpdate:value": ($event: any) => ((item.value) = $event),
                              onKeyup: _withKeys(changeValues, ["enter"]),
                              allowClear: true,
                              placeholder: item.placeholder?item.placeholder:'请输入'
                            }, null, 8, ["value", "onUpdate:value", "placeholder"]))
                          : (item.type=='select')
                            ? (_openBlock(), _createBlock(_component_a_select, {
                                key: 1,
                                value: item.value,
                                "onUpdate:value": ($event: any) => ((item.value) = $event),
                                mode: item.mode,
                                "show-search": "",
                                allowClear: true,
                                onChange: changeValues
                              }, {
                                default: _withCtx(() => [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.list, (option) => {
                                    return (_openBlock(), _createBlock(_component_a_select_option, {
                                      value: option.value,
                                      key: option.value
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(option.label), 1)
                                      ]),
                                      _: 2
                                    }, 1032, ["value"]))
                                  }), 128))
                                ]),
                                _: 2
                              }, 1032, ["value", "onUpdate:value", "mode"]))
                            : (item.type=='radio')
                              ? (_openBlock(), _createBlock(_component_a_radio_group, {
                                  key: 2,
                                  value: item.value,
                                  "onUpdate:value": ($event: any) => ((item.value) = $event),
                                  options: item.list,
                                  onChange: changeValues,
                                  "option-type": item.optionType
                                }, null, 8, ["value", "onUpdate:value", "options", "option-type"]))
                              : (item.type=='daterange')
                                ? (_openBlock(), _createBlock(_component_a_range_picker, {
                                    key: 3,
                                    value: item.value,
                                    "onUpdate:value": ($event: any) => ((item.value) = $event),
                                    valueFormat: "YYYY-MM-DD",
                                    allowClear: true,
                                    onChange: changeValues,
                                    style: {"width":"100%"}
                                  }, null, 8, ["value", "onUpdate:value"]))
                                : (item.type=='date')
                                  ? (_openBlock(), _createBlock(_component_a_date_picker, {
                                      key: 4,
                                      value: item.value,
                                      "onUpdate:value": ($event: any) => ((item.value) = $event),
                                      allowClear: true,
                                      valueFormat: "YYYY-MM-DD",
                                      onChange: changeValues,
                                      style: {"width":"100%"}
                                    }, null, 8, ["value", "onUpdate:value"]))
                                  : (item.type=='inputRange')
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                                        (item.isNumber)
                                          ? (_openBlock(), _createBlock(_component_a_input, {
                                              key: 0,
                                              value: item.value[0],
                                              "onUpdate:value": ($event: any) => ((item.value[0]) = $event),
                                              placeholder: "最小值",
                                              allowClear: true,
                                              onkeyup: "this.value = this.value.replace(/[^\\d.]/g,'')",
                                              onKeyup: _withKeys(changeValues, ["enter"])
                                            }, null, 8, ["value", "onUpdate:value"]))
                                          : (_openBlock(), _createBlock(_component_a_input, {
                                              key: 1,
                                              value: item.value[0],
                                              "onUpdate:value": ($event: any) => ((item.value[0]) = $event),
                                              placeholder: "最小值",
                                              allowClear: true,
                                              onKeyup: _withKeys(changeValues, ["enter"])
                                            }, null, 8, ["value", "onUpdate:value"])),
                                        _cache[0] || (_cache[0] = _createElementVNode("span", null, "-", -1)),
                                        (item.isNumber)
                                          ? (_openBlock(), _createBlock(_component_a_input, {
                                              key: 2,
                                              value: item.value[1],
                                              "onUpdate:value": ($event: any) => ((item.value[1]) = $event),
                                              placeholder: "最大值",
                                              allowClear: true,
                                              onkeyup: "this.value = this.value.replace(/[^\\d.]/g,'')",
                                              onKeyup: _withKeys(changeValues, ["enter"])
                                            }, null, 8, ["value", "onUpdate:value"]))
                                          : (_openBlock(), _createBlock(_component_a_input, {
                                              key: 3,
                                              value: item.value[1],
                                              "onUpdate:value": ($event: any) => ((item.value[1]) = $event),
                                              placeholder: "最大值",
                                              allowClear: true,
                                              onKeyup: _withKeys(changeValues, ["enter"])
                                            }, null, 8, ["value", "onUpdate:value"]))
                                      ]))
                                    : (item.type=='allBlogger')
                                      ? (_openBlock(), _createBlock(CpeH5BloggerSearch, {
                                          key: 6,
                                          modelValue: item.value,
                                          "onUpdate:modelValue": ($event: any) => ((item.value) = $event)
                                        }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                                      : (item.type=='blogger')
                                        ? (_openBlock(), _createBlock(CpeBloggerSearch, {
                                            key: 7,
                                            modelValue: item.value,
                                            "onUpdate:modelValue": ($event: any) => ((item.value) = $event),
                                            mode: item.mode
                                          }, null, 8, ["modelValue", "onUpdate:modelValue", "mode"]))
                                        : (item.type=='director')
                                          ? (_openBlock(), _createBlock(CpeDirectorSearch, {
                                              key: 8,
                                              modelValue: item.value,
                                              "onUpdate:modelValue": ($event: any) => ((item.value) = $event),
                                              mode: item.mode
                                            }, null, 8, ["modelValue", "onUpdate:modelValue", "mode"]))
                                          : (item.type=='cpeProject')
                                            ? (_openBlock(), _createBlock(CpeProjectSearch, {
                                                key: 9,
                                                modelValue: item.value,
                                                "onUpdate:modelValue": ($event: any) => ((item.value) = $event),
                                                mode: item.mode
                                              }, null, 8, ["modelValue", "onUpdate:modelValue", "mode"]))
                                            : (item.type=='cpePlatform')
                                              ? (_openBlock(), _createBlock(CpePlatformSearch, {
                                                  key: 10,
                                                  modelValue: item.value,
                                                  "onUpdate:modelValue": ($event: any) => ((item.value) = $event),
                                                  mode: item.mode
                                                }, null, 8, ["modelValue", "onUpdate:modelValue", "mode"]))
                                              : (item.type=='cpaProject')
                                                ? (_openBlock(), _createBlock(PlatformSearchCpa, {
                                                    key: 11,
                                                    modelValue: item.value,
                                                    "onUpdate:modelValue": ($event: any) => ((item.value) = $event),
                                                    mode: item.mode
                                                  }, null, 8, ["modelValue", "onUpdate:modelValue", "mode"]))
                                                : (item.type=='cpaInviteBlogger')
                                                  ? (_openBlock(), _createBlock(BloggerInviteSearchCpa, {
                                                      key: 12,
                                                      modelValue: item.value,
                                                      "onUpdate:modelValue": ($event: any) => ((item.value) = $event),
                                                      mode: item.mode
                                                    }, null, 8, ["modelValue", "onUpdate:modelValue", "mode"]))
                                                  : (item.type=='cpaBlogger')
                                                    ? (_openBlock(), _createBlock(BloggerSearchCpa, {
                                                        key: 13,
                                                        modelValue: item.value,
                                                        "onUpdate:modelValue": ($event: any) => ((item.value) = $event),
                                                        mode: item.mode
                                                      }, null, 8, ["modelValue", "onUpdate:modelValue", "mode"]))
                                                    : (item.type=='cpaDirector')
                                                      ? (_openBlock(), _createBlock(DirectorSearchCpa, {
                                                          key: 14,
                                                          modelValue: item.value,
                                                          "onUpdate:modelValue": ($event: any) => ((item.value) = $event),
                                                          mode: item.mode
                                                        }, null, 8, ["modelValue", "onUpdate:modelValue", "mode"]))
                                                      : (item.type=='cpaDirectorManager')
                                                        ? (_openBlock(), _createBlock(DirectorManagerSearchCpa, {
                                                            key: 15,
                                                            modelValue: item.value,
                                                            "onUpdate:modelValue": ($event: any) => ((item.value) = $event)
                                                          }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                                                        : (item.type=='cpaKeyword')
                                                          ? (_openBlock(), _createBlock(KeywordSearchCpa, {
                                                              key: 16,
                                                              modelValue: item.value,
                                                              "onUpdate:modelValue": ($event: any) => ((item.value) = $event)
                                                            }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                                                          : (item.type=='allProjects')
                                                            ? (_openBlock(), _createBlock(AllProjectsSearch, {
                                                                key: 17,
                                                                modelValue: item.value,
                                                                "onUpdate:modelValue": ($event: any) => ((item.value) = $event)
                                                              }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                                                            : (item.type=='users')
                                                              ? (_openBlock(), _createBlock(AllUsersSearch, {
                                                                  key: 18,
                                                                  modelValue: item.value,
                                                                  "onUpdate:modelValue": ($event: any) => ((item.value) = $event)
                                                                }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                                                              : _createCommentVNode("", true)
                      ]),
                      _: 2
                    }, 1032, ["label"])
                  ]),
                  _: 2
                }, 1024)), [
                  [_vShow, item.show]
                ])
              }), 128)),
              _createVNode(_component_a_col, { span: buttonSpan.value }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_form_item, null, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_3, [
                        _createVNode(_component_a_button, {
                          type: "primary",
                          ghost: "",
                          onClick: onReset
                        }, {
                          default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                            _createTextVNode("重置", -1)
                          ]))]),
                          _: 1
                        }),
                        _createVNode(_component_a_button, {
                          type: "primary",
                          onClick: onSearch,
                          style: {"margin-left":"10px"}
                        }, {
                          default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                            _createTextVNode("搜索", -1)
                          ]))]),
                          _: 1
                        }),
                        (isShowFold.value)
                          ? (_openBlock(), _createBlock(_component_a_button, {
                              key: 0,
                              type: "primary",
                              shape: "circle",
                              onClick: changeFoldStatus,
                              icon: h(_unref(DoubleRightOutlined)),
                              style: _normalizeStyle([{"margin-left":"10px"}, {'transform': isFold.value ? 'rotate(90deg)' : 'rotate(-90deg)'}])
                            }, null, 8, ["icon", "style"]))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["span"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["labelAlign", "label-col"])
    ])
  ]))
}
}

})